/**
 * our mock data use together with `fake-backend`
 */

let invoices = [
	{
		id: 1,
		name: 'Odette Demageard',
		value: 300,
		email: 'john.doe@email.com',
		date: new Date().getTime()
	},
	{
		id: 2,
		name: 'Vera Taleworth',
		value: 1235,
		email: 'john.doe@email.com',
		date: new Date().getTime()
	},
	{
		id: 3,
		name: 'Lonnie Izkovitz',
		value: 1235,
		email: 'john.doe@email.com',
		date: new Date().getTime()
	},
	{
		id: 4,
		name: 'Thatcher Stave',
		value: 3456,
		email: 'john.doe@email.com',
		date: new Date().getTime()
	},
	{
		id: 5,
		name: 'Karim Chipping',
		value: 5676,
		email: 'john.doe@email.com',
		date: new Date().getTime()
	},
	{
		id: 6,
		name: 'Helge Holyard',
		value: 6789,
		email: 'john.doe@email.com',
		date: new Date().getTime()
	},
	{
		id: 7,
		name: 'Rod Titterton',
		value: 5678,
		email: 'john.doe@email.com',
		date: new Date().getTime()
	},
	{
		id: 8,
		name: 'Gawen Applewhite',
		value: 5678,
		email: 'john.doe@email.com',
		date: new Date().getTime()
	},
	{
		id: 9,
		name: 'Nero Mulgrew',
		value: 579,
		email: 'john.doe@email.com',
		date: new Date().getTime()
	},
	{
		id: 10,
		name: 'Cybill Rimington',
		value: 2356,
		email: 'john.doe@email.com',
		date: new Date().getTime()
	},
	{
		id: 11,
		name: 'Shawna Dubbin',
		value: 1235,
		email: 'john.doe@email.com',
		date: new Date().getTime()
	}
];

export { invoices };
